import { createContext } from "react";

const ResultContext = createContext(undefined as any);

export default ResultContext;
